import { render, staticRenderFns } from "./training-development.vue?vue&type=template&id=05037afd&"
import script from "./training-development.vue?vue&type=script&lang=js&"
export * from "./training-development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports